import { makeStyles } from "tss-react/mui"
import { ListItemIcon, MenuItem, Tooltip, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { TranslationKey } from "../../../modules/localization/translations"

type AvatarMenuItemProps = Readonly<{
    icon: IconDefinition
    tooltipLocalizationId: TranslationKey
    menuItemLocalizationId: TranslationKey
    tooltipFallbackText: string
    menuItemFallbackText: string
    onClick: () => void
    iconClassName?: string
}>

const useStyles = makeStyles()(() => ({
    greyIcon: {
        color: "rgba(0, 0, 0, 0.56)",
    },
    menuIcon: {
        width: "1.25rem",
        height: "1.25rem",
    },
}))

export function AvatarMenuItem({
    icon,
    tooltipLocalizationId,
    menuItemLocalizationId,
    tooltipFallbackText,
    menuItemFallbackText,
    onClick,
    iconClassName,
}: AvatarMenuItemProps) {
    const { classes, cx } = useStyles()

    return (
        <LocalizedStrict id={tooltipLocalizationId} attrs={{ title: true }}>
            <Tooltip title={tooltipFallbackText} placement="left">
                <MenuItem onClick={onClick}>
                    <ListItemIcon>
                        <FontAwesomeIcon
                            icon={icon}
                            className={cx(iconClassName ?? classes.greyIcon, classes.menuIcon)}
                        />
                    </ListItemIcon>
                    <LocalizedStrict id={menuItemLocalizationId}>
                        <Typography display="inline" textAlign="center">
                            {menuItemFallbackText}
                        </Typography>
                    </LocalizedStrict>
                </MenuItem>
            </Tooltip>
        </LocalizedStrict>
    )
}
